import { gql, useQuery } from "@apollo/client";
import {
  ReferrerDataQueryQuery,
  ReferrerDataQueryQueryVariables,
} from "../../../../schemaTypes";

export const REFERRER_DATA_QUERY = gql`
  query ReferrerDataQuery {
    referrerData {
      errors {
        path
        message
      }
      message
      referralCode
      referralPoint
      referrals
    }
  }
`;

export const useReferrerData = () => {
  const { data, loading, error, refetch } = useQuery<
    ReferrerDataQueryQuery,
    ReferrerDataQueryQueryVariables
  >(REFERRER_DATA_QUERY, {
    fetchPolicy: "network-only",
  });

  return {
    data: data?.referrerData || null,
    loading,
    error,
    refetch,
  };
};